import React, { createContext, useContext } from "react";
import type { AssistantApi } from "~/components/assistant/api/AssistantApi";

export type AssistantAppContext = "shared" | "analysis-agent" | "builder-agent";

interface AssistantContextValue {
  api: AssistantApi;
  conversationId: string | null;
  contextId?: string;
  debugMode?: boolean;
  appContext?: AssistantAppContext;
}

const AssistantContext = createContext<AssistantContextValue | null>(null);

interface AssistantProviderProps {
  api: AssistantApi;
  conversationId: string | null;
  contextId?: string;
  debugMode?: boolean;
  appContext?: AssistantAppContext;
  children: React.ReactNode;
}

export function AssistantProvider({
  api,
  conversationId,
  contextId,
  debugMode,
  appContext,
  children,
}: AssistantProviderProps) {
  return (
    <AssistantContext.Provider value={{ api, conversationId, contextId, debugMode, appContext }}>
      {children}
    </AssistantContext.Provider>
  );
}

export function useAssistantContext() {
  const context = useContext(AssistantContext);
  if (!context) {
    throw new Error("useAssistantContext must be used within AssistantProvider");
  }
  return context;
}
